import { SS_VERSION } from 'utils/env';
import { logErrorEventFactory, logResponseErrorFactory } from 'utils/ErrorLogFactory';
export const logErrorEvent = logErrorEventFactory('pathfinder', SS_VERSION);
export const logErrorResponseEvent = logResponseErrorFactory('pathfinder', SS_VERSION);
